import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import BackButton from "../common/BackButton";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";

const apiUrl = Config.apiUrl;

const CompanyManager = () => {
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    // Mesmos padrões das colunas da tabela companies.
    const newEntity = {
        name: '',
        fantasyName: '',
        multiplePaymentMethodsEnabled: false,
        deliveryEnabled: false,
        requireComandaForTable: true,
        showTableOrder: true,
        showComandaOrder: false,
        showTakeAwayOrder: true,
        showCounterOrder: true,
        showWaiterQrCode: true,
        showComandaTable: true,
        showCustomerMenu: false,
    };

    const [formData, setFormData] = useState(null);
    const [uuidCopied, setUuidCopied] = useState(false);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    async function makeQuery() {
        if (!id) {
            setFormData(newEntity);
            return;
        }
        try {
            const url = apiUrl + '/api/companies/id=' + id;
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            setFormData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        makeQuery();
    }, [id]);

    async function saveEntity() {
        const userUUID = Cookies.get('userUUID');
        const url = apiUrl + '/api/companies';
        await makeRequest(url, id ? 'PUT' : 'POST', {
            'Content-Type': 'application/json',
            'Useruuid': userUUID,
        }, JSON.stringify(formData));
    }

    const copyUuid = async () => {
        try {
            await navigator.clipboard.writeText(formData.uuid || '');
            setUuidCopied(true);
            setTimeout(() => setUuidCopied(false), 2000);
        } catch (error) {
            console.error('Error copying uuid:', error);
        }
    };

    const onConfirm = async () => {
        if (!id && (!formData.name || formData.name.trim() === '')) {
            alert('Preencha o campo nome.');
            return;
        }
        try {
            setLoading(true);
            await saveEntity();
            navigate('/companylist');
        } catch (error) {
            console.error('Error saving:', error);
            alert('Erro ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    if (!formData) {
        return null;
    }

    return (
        <div>
            <div className="header-label">{id ? 'Parâmetros da Empresa' : 'Cadastrar Empresa'}</div>

            {id && (
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Código:</div>
                    <input type="text" style={{backgroundColor: '#CCCCCC'}} value={formData.id} disabled={true}/>
                </div>
            )}

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>UUID (SB Printer):</div>
                {formData.uuid ? (
                    <>
                        <input type="text" style={{backgroundColor: '#CCCCCC', width: '300px'}} value={formData.uuid}
                               readOnly/>
                        <button type="button" style={{marginLeft: '8px'}} onClick={copyUuid}>
                            {uuidCopied ? 'Copiado!' : 'Copiar'}
                        </button>
                    </>
                ) : (
                    <input type="text" style={{backgroundColor: '#CCCCCC', width: '300px'}}
                           value="Gerado ao salvar" disabled={true}/>
                )}
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Nome:</div>
                {id ? (
                    <input type="text" style={{backgroundColor: '#CCCCCC', width: '300px'}} value={formData.name || ''}
                           disabled={true}/>
                ) : (
                    <input type="text" style={{width: '300px'}} value={formData.name} name="name"
                           onChange={handleChange}/>
                )}
            </div>

            {!id && (
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Nome fantasia:</div>
                    <input type="text" style={{width: '300px'}} value={formData.fantasyName} name="fantasyName"
                           onChange={handleChange}/>
                </div>
            )}

            <div className="header-label" style={{marginTop: '20px', fontSize: '18px'}}>Parâmetros</div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Múltiplas formas de pagamento no fechamento de comanda?</div>
                <input id="multiplePaymentMethodsEnabled" type="checkbox"
                       checked={!!formData.multiplePaymentMethodsEnabled}
                       name="multiplePaymentMethodsEnabled"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Solicitar comanda para Pedido Mesa?</div>
                <input id="requireComandaForTable" type="checkbox"
                       checked={!!formData.requireComandaForTable}
                       name="requireComandaForTable"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Solicitar mesa para Pedido Comanda?</div>
                <input id="showComandaTable" type="checkbox"
                       checked={formData.showComandaTable !== false}
                       name="showComandaTable"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Cadastro de clientes (Take Away/Delivery)?</div>
                <input id="showCustomerMenu" type="checkbox"
                       checked={!!formData.showCustomerMenu}
                       name="showCustomerMenu"
                       onChange={handleChange}/>
            </div>

            <div className="header-label" style={{marginTop: '20px', fontSize: '18px'}}>Atalhos visíveis no menu</div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Pedido Mesa</div>
                <input id="showTableOrder" type="checkbox"
                       checked={formData.showTableOrder !== false}
                       name="showTableOrder"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Pedido Comanda</div>
                <input id="showComandaOrder" type="checkbox"
                       checked={!!formData.showComandaOrder}
                       name="showComandaOrder"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Pedido Take Away</div>
                <input id="showTakeAwayOrder" type="checkbox"
                       checked={formData.showTakeAwayOrder !== false}
                       name="showTakeAwayOrder"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Pedido Balcão</div>
                <input id="showCounterOrder" type="checkbox"
                       checked={formData.showCounterOrder !== false}
                       name="showCounterOrder"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Pedido Delivery</div>
                <input id="deliveryEnabled" type="checkbox"
                       checked={!!formData.deliveryEnabled}
                       name="deliveryEnabled"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '350px'}}>Garçom · QR Code</div>
                <input id="showWaiterQrCode" type="checkbox"
                       checked={formData.showWaiterQrCode !== false}
                       name="showWaiterQrCode"
                       onChange={handleChange}/>
            </div>

            <ActionButtonsManagerView>
                <BackButton onClick={() => navigate('/companylist')}/>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default CompanyManager;
